import http from "../services/http-common-new";

class NewPinDataService {
    getEditions(number) {
        return http.get(`/newEditions?number=${number}`);
    } 
    getIGLinks() {
        return http.get(`/igLinks`);
    }     
    getLaunch() {
        return http.get(`/launch`);
    }     
    getLaunch2() {
        return http.get(`/launch2`);
    }     
}

export default new NewPinDataService();

